import { faAngleLeft } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import CONTACT_ELEMENTS from "../../Functions/contactElements";
import SCHEME_ELEMENTS from "../../Functions/getElements";
import "./SignsMenu.css";

const SignsMenu = ({ useStore, randomCell, isContactSigns } : { useStore: any, randomCell: { x: number, y: number, page: number | 1 } | null, isContactSigns: boolean }) => {

    const language = useStore((state : any) => state.language || "ro");
    const changeAddSignMenu = useStore((state: any) => state.changeAddSignMenu);
    const addSign = useStore((state: any) => state.addSign);
    const isSelected = useStore((state : any) => state.elements.find((element : any) => element.isSelectedSign));
    const isSelectedCell = useStore((state: any) => state.selectedCell);
    const removeSign = useStore((state: any) => state.removeSign);
    const removeSelectedSign = useStore((state : any) => state.removeSelectedSign);
    const removeSelectedCell = useStore((state: any) => state.removeSelectedCell);
    const location = useLocation();


    useEffect(() => {
        document.body.classList.remove("grid-body");
        document.querySelector("html")?.classList.remove("grid-body");

        const newPageElement : any = document.querySelector(".new-page");
        if (newPageElement) newPageElement.style.display = 'none';
    }, [location]);

    const filteredElements = [...Object.keys(isContactSigns ? CONTACT_ELEMENTS : SCHEME_ELEMENTS)].filter((schemeElement : any) => isContactSigns ? true : SCHEME_ELEMENTS[schemeElement]?.show !== false);

    return (
        <div className="signs-container">

            <h2 className="title">{language === "ro" ? "Semne" : "Signs"}</h2>
            <div className="go-back" onClick={() => changeAddSignMenu()}>
                <FontAwesomeIcon icon={faAngleLeft} className="icon" />
            </div>
            <div className="types">

            </div>

            <div className="elements">
                {filteredElements.map((schemeElement : any, idx : number) => (
                    <div className="element" key={idx} onClick={() => {
                        if (isSelected) {
                            const currX = isSelected.x;
                            const currY = isSelected.y;
                            const currPage = isSelected.page;
                            removeSign(currX, currY, currPage);
                            if (isContactSigns) {
                                const contactElements : any = CONTACT_ELEMENTS;
                                contactElements[schemeElement].realSource.forEach((source: any, idx: number) => {
                                    addSign(currX - idx, currY, currPage, SCHEME_ELEMENTS[`${isSelected.name}_${schemeElement}`], 0, []);
                                });
                            } else {

                                SCHEME_ELEMENTS[schemeElement].realSource.forEach((source : any, idx : number) => {
                                    addSign(currX - idx, currY, currPage, source, 0, []);
                                });
                            }
                        
                        }
                        else if (isSelectedCell) {
                            SCHEME_ELEMENTS[schemeElement].realSource.forEach((source : any, idx : number) => {
                                addSign(isSelectedCell.x - idx, isSelectedCell.y, isSelectedCell.page, source, 0, []);
                            });
                        } else if (randomCell) SCHEME_ELEMENTS[schemeElement].realSource.forEach((source : any, idx : number) => {
                            addSign(randomCell.x - idx, randomCell.y, randomCell.page, source, 0, []);
                        });

                        document.body.classList.add("grid-body");
                        document.querySelector("html")?.classList.add("grid-body");

                        removeSelectedCell();
                        removeSelectedSign();
                        changeAddSignMenu();
                        const newPageElement : any = document.querySelector(".new-page");
                        if (newPageElement) newPageElement.style.display = 'flex';
                    }}>
                        <div className="element-image">
                            <img src={SCHEME_ELEMENTS[schemeElement].imageSource} alt={language === "ro" ? "Semn Imagine" : "Image Sign"} />
                        </div>
                        <p>{SCHEME_ELEMENTS[schemeElement].name[language]}</p>
                    </div>
                ))}
            </div>
        </div>
    );
};

export default SignsMenu;